export default import.meta.ROLLDOWN_FILE_URL_NkgtmFRqL3gL3KvqfzInvQ